import { GameEntity } from "../GameEntity/GameEntity";
import { Bullet } from "../Bullet/Bullet";
const redColor = "#FF0000";

class SmallEnemy extends GameEntity {
  constructor(game) {
    const width = 80;
    const height = 80;
    const velocityY = Math.random() * 0.1 + 0.1;
    const shootInterval = 3000;

    super(game, width, height, redColor, velocityY, "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/ship13.webp");

    this.x = Math.random() * (this.game.width * 0.95 - width);
    this.y = -this.height;
    
    this.shootTimer = 0;
    this.shootInterval = shootInterval;
  }

  update(deltaTime) {
    super.update(deltaTime);

    this.shootTimer += deltaTime;
    if (this.shootTimer > this.shootInterval) {
      this.game.player.bullets.push(
        new Bullet(
          this.x + this.width / 2,
          this.y + this.height,
          this.game,
          redColor,
          true
        )
      );
      this.shootTimer = 0;
    }
  }
}

export { SmallEnemy };
